import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const VrfSlice =  createSlice({
    name:"VRF",
    initialState:{
        id:"",
    },
    reducers:{
        SetvRF(state, action: PayloadAction<any>){
            state.id = action.payload;

        }
    }
});

export const { SetvRF } =VrfSlice.actions
export default VrfSlice.reducer